var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-player-wrapper" }, [
    _c(
      "video",
      {
        ref: "introVideo",
        attrs: {
          preload: "metadata",
          playsinline: "",
          width: "100%",
          height: _vm.height,
          controls: _vm.controls,
          autoplay: _vm.autoplay,
          loop: _vm.loop,
        },
        domProps: { muted: _vm.muted },
      },
      [
        _c("source", {
          attrs: { src: _vm.videoUrl + ".webm#t=0.1", type: "video/webm" },
        }),
        _c("source", {
          attrs: { src: _vm.videoUrl + ".mp4#t=0.1", type: "video/mp4" },
        }),
        _c("source", {
          attrs: { src: _vm.videoUrl + ".ogv#t=0.1", type: "video/ogv" },
        }),
        _vm._v(" Your browser does not support the video tag. "),
      ]
    ),
    _vm.isVideoPaused
      ? _c("div", {
          staticClass: "video-button",
          on: { click: _vm.videoPlayToggle },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }